<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width client-autocomplete"
               remote
               :allow-create="allowCreate"
               :loading="loading"
               :placeholder="$t('generic.searchOrCreate')"
               :remote-method="onRemoteMethod"
               :value="clientValue"
               :clearable="clearable"
               filterable
               default-first-option
               @change="onChange"
               @clear="onClear"
               v-bind="$attrs"
               value-key="name">
      <el-option v-for="client in clients.data"
                 class="select-default client-autocomplete__option"
                 :key="client.uuid"
                 :label="client.name"
                 :value="client">
        <div class="flex items-center py-1">
          <img class="mr-2 option-image-sm" v-if="client.image" :src="client.image" :alt="client.name">
          <span>{{client.name}}</span>
        </div>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import throttle from 'lodash/throttle'
  import ClientService from 'src/services/ClientService'

  export default {
    name: 'client-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      client: {
        type: Object,
        default: () => {
          return {
            name: ''
          }
        }
      },
      searchByNameOnMounted: {
        type: Boolean,
        default: true
      },
      clearable: Boolean,
      searchParams: {
        type: Object,
        default: () => ({})
      },
      label: {
        type: String
      },
      allowCreate: {
        type: Boolean,
        default: true
      },
      excludeClients: {
        type: Array,
        default: () => []
      }
    },
    model: {
      prop: 'client',
      event: 'change'
    },
    data () {
      return {
        loading: false,
        clients: [],
        selectedValue: null
      }
    },
    computed: {
      clientValue () {
        if (!this.client) {
          return null
        }
        if (!this.client.uuid) {
          return this.client.name
        }
        return this.client
      }
    },
    methods: {
      async searchClients (query) {
        try {
          this.loading = true
          let results = await ClientService.get({
            query,
            limit: 20,
            sort: '-name',
            ...this.searchParams
          })
          results.data = results.data.filter(client => {
            return this.excludeClients.find(c => c.id === client.id) === undefined
          })
          this.clients = results
        } catch (e) {
          console.warn(e)
        } finally {
          this.loading = false
        }
      },
      async onChange (val) {
        if (!val) {
          this.onRemoteMethod(val)
        }

        let model = val
        if (typeof val === 'string') {
          model = await this.createNewClient(val)
          await this.searchClientByName(val)
        }
        this.selectedValue = model
        this.$emit('change', model)
      },
      async onClear() {
        this.selectedValue = null;
        this.$emit('change', null);
        return;
      },
      async createNewClient(name) {
        const { data } = await ClientService.create({
          name: name,
          status: 'active',
          type: 'organisation'
        })
        return data
      },
      async searchClientByName (name) {
        if (!this.searchByNameOnMounted) {
          name = ''
        }
        await this.searchClients(name)
        if (name) {
          let model = this.clients.data.find(c => c.name === this.client.name)
          if (model) {
            this.onChange(model)
          }
        }
      }
    },
    created () {
      this.onRemoteMethod = throttle(this.searchClients, 200)
    },
    async mounted () {
      let name = this.client ? this.client.name : ''
      await this.searchClientByName(name)
    },
    watch: {
      'client.name': {
        immediate: true,
        async handler (name) {
          if (name && !this.selectedValue) {
            await this.searchClientByName(name)
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .option-image-sm {
    width: auto;
    height: auto;
    max-height: 40px;
  }

  .client-autocomplete {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }

  .el-select-dropdown .el-select-dropdown__item.client-autocomplete__option {
    height: 50px;
    line-height: 42px;
    border-bottom: 1px solid $hr-line;
  }
</style>
